import { extendTheme, StyleFunctionProps } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

import { colors } from '../colors';
import { Alert } from './components/Alert';
import { Button } from './components/Button';
import { ChakraReactDatePicker } from './components/ChakraReactDatePicker';
import { Drawer } from './components/Drawer';
import { Modal } from './components/Modal';
import { Progress } from './components/Progress';
import { Stepper } from './components/Stepper';
import { Table } from './components/Table';
import { Tabs } from './components/Tabs';
import { fontFamily } from './typography';

export const components = {
  Alert,
  Button,
  ChakraReactDatePicker,
  Drawer,
  Modal,
  Progress,
  Stepper,
  Table,
  Tabs,
} as const;

export const theme = extendTheme({
  colors,
  components,
  fonts: {
    heading: fontFamily,
    body: fontFamily,
  },
  styles: {
    global: (props: StyleFunctionProps) => ({
      'body, #root': {
        background: mode(colors.white, colors.gray['950'])(props),

        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      },
      // See https://github.com/chakra-ui/chakra-ui/issues/7629
      '.chakra-input__group': {
        isolation: 'auto !important',
      },
    }),
  },
});
